// caminho: apps/web/src/components/auth/PermissionGuard.js
// data e hora da modificação: 2026-03-18 19:28

import React from "react";
import { Navigate } from "react-router-dom";
import {
  hasAllPermissions,
  hasAnyPermission,
  hasPermission,
} from "utils/permissions";

const PermissionGuard = ({
  permission,
  anyOf = [],
  allOf = [],
  redirectTo = "/app/errors/error-403",
  children,
}) => {
  let allowed = true;

  if (permission) {
    allowed = hasPermission(permission);
  }

  if (allowed && anyOf.length > 0) {
    allowed = hasAnyPermission(anyOf);
  }

  if (allowed && allOf.length > 0) {
    allowed = hasAllPermissions(allOf);
  }

  if (!allowed) {
    return <Navigate to={redirectTo} replace />;
  }

  return children;
};

export default PermissionGuard;